import { useMutation } from '@tanstack/react-query';
import { submitListZeroApi } from '../api/api';
import { ListSubmitPayload } from '../ListZero.types';

export function useSubmitListZeroMutation() {
  return useMutation({
    mutationFn: (payload: ListSubmitPayload) => submitListZeroApi(payload),
  });
}
